import React, { FunctionComponent } from 'react';

import { Breadcrumb } from '@savebetter/components';

import { getCrumbHref, getCrumbLabel, getCrumbName } from '../utils';

interface BreadcrumbsProps {
  currentCrumb: string;
  crumbPaths: string[];
  separator?: string;
}
const Breadcrumbs: FunctionComponent<React.PropsWithChildren<BreadcrumbsProps>> = ({
  currentCrumb,
  crumbPaths,
  separator = '>'
}) => (
  <Breadcrumb className="breadcrumbs pt-4 pb-8" separator={separator}>
    {crumbPaths.map(route => {
      const crumbLabel = getCrumbLabel(route);

      return getCrumbName(route) === currentCrumb ? (
        <span key={route}>{crumbLabel}</span>
      ) : (
        <a key={route} href={getCrumbHref(route)}>
          {crumbLabel}
        </a>
      );
    })}
  </Breadcrumb>
);

export default Breadcrumbs;
